// Stolen from https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js

function isStyleVisible(element) {
  const { display, visibility, opacity } = getComputedStyle(element)
  return display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse' && opacity !== '0' && opacity !== 0
}

function isAttributeVisible(element, previousElement) {
  let detailsVisibility

  if (previousElement) {
    detailsVisibility =
      element.nodeName === 'DETAILS' && previousElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true
  } else {
    detailsVisibility = element.nodeName === 'DETAILS' ? element.hasAttribute('open') : true
  }

  return !element.hasAttribute('hidden') && detailsVisibility
}

function isElementVisible(element, previousElement) {
  return (
    isStyleVisible(element) &&
    isAttributeVisible(element, previousElement) &&
    (!element.parentElement || isElementVisible(element.parentElement, element))
  )
}

export default function isVisible(element) {
  const isInDocument = element.ownerDocument === element.getRootNode({ composed: true })
  return isInDocument && isElementVisible(element)
}
